import * as mocks from '../../mocks/posts';

class MockPostsRepository {
    
    getMediaPost(postId){
        return Promise.resolve(mocks.getMediaPost(postId));
        
    }
}
export default MockPostsRepository;